/**
 * @deprecated Not used in Marketplace 2.0
 */
export enum MarketplaceType {
  DESIGN_TEMPLATE = 'design_template',
  SAMPLE_PRESENTATION = 'sample_presentation',
  AUTOMATION_TEMPLATE = 'automation_template'
}
